import { createAction } from 'redux-actions';
/**
 * Used to update the value in the `email` reducer of the `subscription` model.
 *
 * Has the type `UPDATE_EMAIL`.
 *
 * Meant to be used in conjunction with an input to automatically update the value as the user enters it.
 *
 * ```js
 * // in a component
 * import { subscription, Input } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   const { updateEmail } = subscription.hooks.useSubscriptionActions();
 *   return (
 *     <Input onChange={(e) => updateEmail(e.target.value)} />
 *   )
 * }
 *
 * // outside of a react component (eg. a redux thunk)
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * const email = 'test@gmail.com';
 * dispatch(subscription.actions.updateEmail(email));
 * ```
 *
 * @returns {Object} - A redux action that can be dispatched by redux
 */

var updateEmail = createAction('UPDATE_EMAIL');
export default updateEmail;